<div class="wrapper">
  <div class="row--container">
    <div class="row">
      <div class="col-5">
        <p class="landing-header">Customer Profile</p>
        <p class="landing-header">Now Simplified</p>
        <p class="landing-highlights">Get a complete overview of the users's profile Including</p>
        <ul class="landing-highlights">
          <li>Account SignUp Status</li>
          <li>
            Authorizations (Now Apps & Datastreams)<mat-icon color="primary">new_releases</mat-icon>
          </li>
          <li>Check MILA LabResults<mat-icon color="primary">new_releases</mat-icon></li>
        </ul>
        <br />
        <a class="effect1" routerLink="../profile">
          Let's Find Out!
          <span class="bg"></span>
        </a>
      </div>
      <div class="col-3">
        <img src="assets/undraw_team_ih79.svg" />
      </div>
    </div>
  </div>
</div>
